import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';
import { WalletserviceService } from 'src/app/services/walletservice.service';
import { SocketService } from 'src/app/services/socket.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-network-charts',
  templateUrl: './network-charts.component.html',
  styleUrls: ['./network-charts.component.css']
})
export class NetworkChartsComponent implements OnInit {

  nietos = []
  priceList: any
  element: any;
  balanceCount: any;
  userBalance: any[];
  addressCount: any
  userAddress: any[];
  listSR: any;
  nextRound: any;
  charts = [];
  voteAccounts: any[];
  SrElement: any;
  voCount: any;
  chartName: any;
  voteaddress: string;
  chartColor: any;
  // piechartColor = (localStorage.getItem("Sastana-Theme") == 'darktheme') ? '#2740a6' : '#2740a6';

  constructor(private walletservice: WalletserviceService, private conn: ConnectionService, private alert: ToastrService, private activatedRoute: ActivatedRoute, private router: Router, private socketService: SocketService, private spinner: NgxSpinnerService
  ) {
    this.conn.setColor.subscribe((res: any) => {
      this.chartColor = res == 'lighttheme' ? '#000000' : '#ffffff'
    })
  }

  ngOnInit() {
    this.chartName = this.activatedRoute.snapshot.params['name'];
    this.getSR();
    this.getSRVotes()
  }

  socketCharts(): any {
    this.socketService.latestBlocks().subscribe((res: any) => {
      if (res == 'latestblocks') {
        this.getSRVotes()
      }
    });
  }

  getSR() {
    // this.spinner.show()
    this.conn.getUrl('superRep/getAllWitness').subscribe((res: any) => {
      // this.spinner.hide()

      this.listSR = res.data;
      for (var j = 0; j < this.listSR.length; j++) {
        this.nextRound = this.listSR[0].nextRound;
        this.listSR[j].position = j + 1;
        this.listSR[j].random = Math.floor(Math.random() * 2);
        var totalProduced = this.listSR[j].totalProduced;
        var totalMissed = this.listSR[j].totalMissed;

        var name = this.listSR[j].address;
        var count = this.listSR[j].voteCount;
        var obj = {};
        obj["name"] = name
        obj["y"] = totalProduced;
        obj["missed"] = totalMissed

        this.nietos.push(obj);
      }
      this.createPieChart()
      this.conn.clearbackground();
    });
  }





  createPieChart() {
    // Highcharts.setOptions({
    //   chart: {
    //     style: {
    //       fontFamily: 'Lato' // Specify the desired font family here
    //     }
    //   }
    // });
    Highcharts.chart('chart-pie', {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: '',
        style: {
          color: this.chartColor,
        }
      },
      tooltip: {
        pointFormat: '<br>Blocks produced : <b>{point.y}</b><br/><br>Blocks Missed : <b>{point.missed}</b><br/>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            style: {
              color: this.chartColor
            }
          },
          // showInLegend: true
        }
      },
      series: [{
        name: 'Blocks',
        colorByPoint: true,
        innerSize: '50%',
        // color: '#2740a6',
        data: this.nietos
      }]
    } as any);
  }


  getSRVotes() {
    this.conn.postUrl('users/srVoteChart', {}).subscribe((res: any) => {
      this.listSR = res.data;
      this.voteAccounts = []
      let categoriesData = []
      for (let index = 0; index < this.listSR.length; index++) {
        this.SrElement = this.listSR[index];
        this.voCount = this.SrElement.voteCount
        this.voteAccounts.push(this.voCount)
        this.voteaddress = this.listSR[index].address.slice(0, 3) + '..' + this.listSR[index].address.slice(30, 34)
        categoriesData.push(this.voteaddress)
        this.Srchart(categoriesData);
      }
    });
  }

  Srchart(category: any) {
    Highcharts.chart('sr_votes', {
      chart: {
        type: 'area'
      },
      accessibility: {
        description: '',
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        categories: category
      },
      yAxis: {
        title: {
          text: ''
        },
      },
      tooltip: {
        pointFormat: '{series.name} <b>{point.y:,.0f}</b><br/>'
      },
      plotOptions: {
        series: {
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
        // area: {
        //   marker: {
        //     enabled: false,
        //     symbol: 'circle',
        //     radius: 2,
        //     states: {
        //       hover: {
        //         enabled: true
        //       }
        //     }
        //   }
        // }
      },
      series: [{
        name: 'Votes',
        color: '#2740a6',
        data: this.voteAccounts
      }],
    } as any);
  }
}
